import script from "./HowWeWork.vue?vue&type=script&setup=true&lang=js"
export * from "./HowWeWork.vue?vue&type=script&setup=true&lang=js"

import "./HowWeWork.vue?vue&type=style&index=0&id=5da65dab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da65dab"]])

export default __exports__